import { ApiError } from "@softmax/observatory-client/transport";
import type { ReadResult } from "@/lib/read-result";

export function readResult<T>(read: () => Promise<T>): Promise<ReadResult<T>> {
  return read().then(
    (data) => ({ kind: "ready", data }),
    (error: unknown) => {
      if (error instanceof ApiError)
        return {
          kind: "unavailable",
          status: error.status,
          message: error.message,
        };

      throw error;
    },
  );
}
